import { dynamicLoader } from '~/utils';

export const Header = dynamicLoader({
  name: 'Header',
  importFunc: () => import('./header'),
});